import { render, staticRenderFns } from "./CfoTaskQueueHistory.vue?vue&type=template&id=687fb4b3&scoped=true"
import script from "./CfoTaskQueueHistory.vue?vue&type=script&lang=js"
export * from "./CfoTaskQueueHistory.vue?vue&type=script&lang=js"
import style0 from "./CfoTaskQueueHistory.vue?vue&type=style&index=0&id=687fb4b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687fb4b3",
  null
  
)

export default component.exports